module.exports = __webpack_public_path__ + "images/emails/logo-wildbit-6d74b93d.gif";